/* eslint-disable id-length */
import { completeTypes, createTypes, withPostFailure, withPostSuccess } from 'redux-recompose';
import { push } from 'connected-react-router';

import * as AdelphiStatementsService from '#services/AdelphiStatementsService';
import ModalActions from '#redux/Modal/actions';
import { MODALS } from '#redux/Modal/constants';
import { ROUTES } from '#constants/routes';

import { ADELPHI_STATEMENTS_TARGETS } from './constants';

export const actions = createTypes(
  completeTypes({
    primaryActions: [
      'GET_ALL_STATEMENTS',
      'CREATE_ADELPHI_STATEMENT',
      'GET_STATEMENT_BY_ID',
      'GENERATE_STATEMENT_CSV_BY_ID',
      'DELETE_STATEMENT_BY_ID'
    ],
    ignoredActions: ['SET_CURRENT_ADELPHI_STATEMENT']
  }),
  '@@ADELPHI_STATEMENTS'
);

export const actionCreators = {
  getAllStatements: () => ({
    type: actions.GET_ALL_STATEMENTS,
    target: ADELPHI_STATEMENTS_TARGETS.ADELPHI_STATEMENTS,
    service: AdelphiStatementsService.getAllAdelphiStatements
  }),
  getStatementById: ({ id }) => ({
    type: actions.GET_STATEMENT_BY_ID,
    target: ADELPHI_STATEMENTS_TARGETS.ADELPHI_STATEMENT_BY_ID,
    service: AdelphiStatementsService.getAdelphiStatementById,
    payload: { id },
    successSelector: response => response.data.statement
  }),
  createAdelphiStatement: ({ periodId, prevPeriodId, feintPeriodId }) => ({
    type: actions.CREATE_ADELPHI_STATEMENT,
    target: ADELPHI_STATEMENTS_TARGETS.CREATE_ADELPHI_STATEMENT,
    service: AdelphiStatementsService.createAdelphiStatement,
    payload: { periodId, prevPeriodId, feintPeriodId },
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllStatementsAndCloseModal(MODALS.ADELPHI_STATEMENT));
      }),
      withPostFailure((dispatch, error) => {
        dispatch(
          push(
            `${ROUTES.ERROR.path}?errorMessage=${encodeURIComponent(
              error.data[0].message || 'Unknown Error'
            )}`
          )
        );
      })
    ]
  }),
  generateAdelphiStatementCSVById: ({ id }) => ({
    type: actions.GENERATE_STATEMENT_CSV_BY_ID,
    target: ADELPHI_STATEMENTS_TARGETS.ADELPHI_STATEMENT_CSV_BY_ID,
    service: AdelphiStatementsService.generateAdelphiStatementCSVById,
    payload: { id },
    successSelector: response => response.data.id,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(ModalActions.openModal(MODALS.CSVS_GENERATED));
      }),
      withPostFailure(dispatch => {
        dispatch(push(ROUTES.ERROR.path));
      })
    ]
  }),
  getAllStatementsAndCloseModal: modal => dispatch => {
    dispatch(actionCreators.getAllStatements());
    dispatch(ModalActions.closeModal(modal));
  },
  setCurrentStatement: payload => ({
    type: actions.SET_CURRENT_ADELPHI_STATEMENT,
    target: ADELPHI_STATEMENTS_TARGETS.CURRENT_ADELPHI_STATEMENT,
    payload
  }),
  deleteStatementById: ({ id }) => ({
    type: actions.DELETE_STATEMENT_BY_ID,
    target: ADELPHI_STATEMENTS_TARGETS.ADELPHI_STATEMENT_BY_ID,
    service: AdelphiStatementsService.deleteAdelphiStatementById,
    payload: { id },
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllStatementsAndCloseModal(MODALS.DELETE_RECORD));
        dispatch(actionCreators.setCurrentStatement(null));
      })
    ]
  })
};

export default actionCreators;
